import { categories } from "@/mocks/categories";

export default function CategoryCards() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4">
            Browse By Category
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Discover <span className="text-primary-500">Product Categories</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            Explore organized product categories through the Hipobuy Spreadsheet — find exactly what you are looking for
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 max-w-6xl mx-auto">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center group-hover:bg-secondary-200 transition-colors">
                <i className={`${cat.icon} text-secondary-600 text-lg group-hover:text-secondary-700 transition-colors`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 text-center group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 text-center leading-relaxed line-clamp-2">
                {cat.description}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}